import React, { Component } from 'react';

import find from 'lodash/find';
import get from 'lodash/get';

import Input from 'ui/Input';

import { ControlPassSubject } from 'shared/ControlPassSubject';


class Checkboxes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxValues: props.defaultSelected || [],
    };
  }

  toggleOption = (option) => {
    const optionIndex = this.state.checkboxValues.indexOf(option.value);

    const checkboxValues = [...this.state.checkboxValues];
    
    if (optionIndex === - 1) {
      checkboxValues.push(option.value);
    } else {
      checkboxValues.splice(optionIndex, 1);
    }
    
    
    this.setState({ checkboxValues });
    
    const onChange = this.props.onChange;
    
    if (onChange) {
      onChange(checkboxValues);
    }
    
    let fieldResponses = {}

    checkboxValues.forEach(value => {
      let field = find(this.props.fieldDefs, [`${this.props.valueKey}`, value]);

      fieldResponses[get(field, 'id')] = value;
    })
    
    ControlPassSubject.next({ field: fieldResponses, controlType: 'checkbox'});
  }

  render() {
    const { values } = this.props;

    let children = values.map((item, index) => (
      <Input
        key={index}
        nameVal={item.value}
        itemValue={item.value} 
        title={item.label}
        checked={this.state.checkboxValues.indexOf(item.value) !== -1}
        onChange={() => this.toggleOption(item)}
        nature="checkbox" />
    ));

    return (
      <div>
        {children}
      </div>
    );
  }
}

export default Checkboxes;


// WEBPACK FOOTER //
// ./src/ui/Checkboxes.js